export class LanguagesData {
    private languagesList: string[] = [
        'EN',
        'RU'];

    public getLanguages(): Array<string> {
        return this.languagesList;
    }
}
